/** @jsx h */
import { h } from 'preact'

const Facebook = () => (
  <svg
    class='JourneyShare-icon'
    xmlns='http://www.w3.org/2000/svg'
    width='50'
    height='50'
    viewBox='0 0 50 50'
  >
    <path d='M35.748 25h-6.9v25H18.504V25h-5.17v-8.617h5.17v-5.17C18.504 4.18 21.424 0 29.714 0h6.898v8.617h-4.31c-3.228 0-3.442 1.206-3.442 3.452l-.013 4.313h7.817L35.748 25z' />
  </svg>
)

const Twitter = () => (
  <svg
    class='JourneyShare-icon'
    xmlns='http://www.w3.org/2000/svg'
    width='50'
    height='50'
    viewBox='0 0 50 50'
  >
    <path d='M44.884 14.804c.02.44.025.88.025 1.327 0 13.554-10.317 29.187-29.184 29.187-5.794 0-11.188-1.697-15.726-4.61.804.098 1.62.144 2.45.144 4.806 0 9.228-1.64 12.736-4.388-4.49-.083-8.277-3.048-9.58-7.124.623.12 1.27.185 1.93.185.934 0 1.84-.127 2.7-.36-4.693-.946-8.226-5.09-8.226-10.06v-.13c1.382.767 2.965 1.233 4.645 1.282-2.75-1.84-4.565-4.98-4.565-8.536 0-1.885.51-3.644 1.39-5.16C8.54 12.766 16.1 16.85 24.63 17.28c-.176-.75-.27-1.533-.27-2.338 0-5.666 4.594-10.257 10.258-10.257 2.95 0 5.62 1.245 7.492 3.236 2.335-.46 4.53-1.312 6.512-2.488-.765 2.396-2.393 4.406-4.51 5.676 2.073-.248 4.05-.8 5.89-1.617-1.377 2.06-3.114 3.864-5.116 5.314' />
  </svg>
)

const JourneyShareIcon = ({ type, link }) => {
  if (type === 'twitter') {
    return (
      <a
        class='JourneyShare-button JourneyShare-button--twitter'
        href={link}
        target='_blank'
        rel='noopener noreferrer'
      >
        <Twitter />
      </a>
    )
  }

  return (
    <a
      class='JourneyShare-button JourneyShare-button--facebook'
      href={link}
      target='_blank'
      rel='noopener noreferrer'
    >
      <Facebook />
    </a>
  )
}

export default JourneyShareIcon
